import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-container"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "container-btn-action" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (!$setup.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataOptions, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex align-items-center mb-3"
          }, [
            _createVNode(_component_Checkbox, {
              modelValue: $setup.selectedPassenger,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedPassenger) = $event)),
              inputId: index,
              name: "data",
              value: item.Id,
              disabled: $setup.selectedPassengerTemp.includes(item.Id)
            }, null, 8, ["modelValue", "inputId", "value", "disabled"]),
            _createElementVNode("label", {
              for: index,
              class: "ml-2"
            }, _toDisplayString(item.Type), 9, _hoisted_2)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            class: "btn-back mr-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hideModalForm()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            onClick: $setup.submitData,
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
    : _createCommentVNode("", true)
}